import { v4 as uuidv4 } from "uuid";
export class LiveViewUserModeEntryModel {
    constructor() {
        this.clockWorkEntryId = uuidv4();
        this.employeeId = "";
        this.fullName = "";
        this.teamId = "";
        this.teamName = "";
        this.profileImageUrl = "";
        this.startTime = null;
        this.endTime = null;
        this.startTimeTzFormatted = "";
        this.endTimeTzFormatted = "";
        this.description = "";
        this.totalTimeInSeconds = 0;
        this.projectDisplayString = "";
        this.taskDisplayString = "";
        this.projectId = "";
        this.taskCode = "";
        this.projectCode = "";
        this.isViewable = false;
        this.isWFO = false;
    }
}
export default class LiveViewUserModeEntry extends LiveViewUserModeEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
